<template>
  <div class="payment-info error-payment">
    <div class="payment-header error">支払情報</div>
    <div class="payment-content">
      <div
        class="payment-row d-flex justify-content-between align-items-center"
      >
        <div class="payment-label">振込不能理由</div>
        <div class="payment-value error-message">
          {{ errorReason }}
        </div>
      </div>

      <div v-if="expirationManualDate !== ''"
        class="payment-row d-flex justify-content-between align-items-center" >
        <div class="payment-label">受給権消滅日</div>
        <div class="payment-value error-message">
          {{ expirationManualDate }}
        </div>
      </div>

      <div class="payment-row d-flex justify-content-between">
        <div class="payment-label">金額</div>
        <div class="payment-value amount">{{ amount }}円</div>
      </div>

      <!-- 振込口座に関する注意書き
      <div class="error-note">
        <p>
          振込口座が未登録又は、振込エラーにより振込手続きがとれないお支払があります。
        </p>
        <p>
          誠に恐れ入りますが、別途お送りした「ゆうちょ銀行振込依頼書」にご記入の上ご返送くださいますようお願いいたします。
        </p>
        <p>
          なお、支払期日から６ヶ月以内に振込口座の指定または再指定が無い場合は、その６ヶ月の経過をもって受給権は消滅します。
        </p>
        <p>
          ご不明な点につきましては、お手数ですがフリーダイヤル（0120-268-510）までお問合せくださいますようお願いいたします。
        </p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorPaymentInfo",
  props: {
    errorReason: {
      type: String,
      default: "振込口座未登録",
    },
    expirationDate: {
      type: String,
      default: "",
    },
    expirationManualDate: {
      type: String,
      default: "",
    },
    amount: {
      type: String,
      default: "0",
    },
  },
};
</script>

<style scoped>
.payment-info {
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.payment-header {
  padding: 10px 15px;
  font-weight: 600;
  border-radius: 4px 4px 0 0;
}

.payment-header.error {
  background-color: #ffeeee;
  color: #c0392b;
}

.payment-content {
  padding: 15px;
}

.payment-row {
  padding: 8px 0;
  border-bottom: 1px dotted #ddd;
}

.payment-row:last-child {
  border-bottom: none;
}

.d-flex {
  display: flex;
}

.justify-content-between {
  justify-content: space-between;
}

.align-items-center {
  align-items: center;
}

.payment-value.amount {
  font-weight: 600;
  color: #e74c3c;
}

.payment-value.error-message {
  color: #c0392b;
  font-weight: 600;
}

.error-note {
  margin-top: 15px;
  padding: 10px;
  background-color: #ffeeee;
  border-radius: 4px;
  font-size: 0.9rem;
}

.error-note p {
  margin: 5px 0;
}
</style> 